/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessReferralWebPreferencesResource
 */
export interface BusinessReferralWebPreferencesResource {
    /**
     * user has been onboarded
     * @type {boolean}
     * @memberof BusinessReferralWebPreferencesResource
     */
    onboardingAcknowledged: boolean;
}

/**
 * Check if a given object implements the BusinessReferralWebPreferencesResource interface.
 */
export function instanceOfBusinessReferralWebPreferencesResource(value: object): value is BusinessReferralWebPreferencesResource {
    if (!('onboardingAcknowledged' in value) || value['onboardingAcknowledged'] === undefined) return false;
    return true;
}

export function BusinessReferralWebPreferencesResourceFromJSON(json: any): BusinessReferralWebPreferencesResource {
    return BusinessReferralWebPreferencesResourceFromJSONTyped(json, false);
}

export function BusinessReferralWebPreferencesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReferralWebPreferencesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'onboardingAcknowledged': json['onboardingAcknowledged'],
    };
}

export function BusinessReferralWebPreferencesResourceToJSON(value?: BusinessReferralWebPreferencesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'onboardingAcknowledged': value['onboardingAcknowledged'],
    };
}

